// ============================================================================
// CONGOLESE (LINGALA) TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Bolimboli ya theologie na ntina ya Yesu (Komonisa bolingo oyo eyambaka bato nyonso)

export const jesusIsNotRc = [
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali moyini ya bato te",
    reference: "Yoane 4:9",
    context: "Yesu asolanaki na mwasi ya Samaria, alongolaki mikakatano ya bikolo mpe ya mimeseno"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali moto oyo aboyaka bato te",
    reference: "Matai 11:28",
    context: "Azali kobenga bato nyonso mpe aboyaka motema moko te oyo ezali ya solo"
  },
  {
    category: "Bolingo",
    text: "Yesu alingaka na mabongisi te",
    reference: "Baroma 5:8",
    context: "Akufaki mpo na biso ntango tozalaki naino basumuki"
  },
  {
    category: "Mawa",
    text: "Yesu ayaki kosambisa kaka te",
    reference: "Yoane 3:17",
    context: "Mokano na Ye ya liboso ezali kobikisa mokili"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali mpo na ekolo moko kaka te",
    reference: "Yoane 10:16",
    context: "Azali na mpata mosusu oyo euti na bikolo nyonso"
  },
  {
    category: "Bokokani",
    text: "Yesu azali mpo na bato ya likolo kaka te",
    reference: "Marko 2:17",
    context: "Azalaki na babeli, babola, mpe baoyo basundolaki"
  },
  {
    category: "Mawa",
    text: "Yesu azali moto oyo alimbisaka te",
    reference: "Luka 23:34",
    context: "Ata na likonzi, alimbisaki"
  },
  {
    category: "Bolingo",
    text: "Yesu azali moto oyo ayokaka mawa te",
    reference: "Matai 9:36",
    context: "Ntango amonaki bato ebele, ayokaki mawa mingi na bango"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali moyini ya basi te",
    reference: "Yoane 20:17",
    context: "Azalaki kopesa lokumu na basi mpe aponaki bango lokola batatoli ya liboso ya lisekwa"
  },
  {
    category: "Mawa",
    text: "Yesu azali mobomi te",
    reference: "Matai 5:39",
    context: "Alakisaki kimia mpe koboma te"
  },
  {
    category: "Bokokani",
    text: "Yesu azali mosika te",
    reference: "Matai 28:20",
    context: "Alakaki kozala na biso tii na nsuka ya mokili"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali mpo na lolenge moko ya bato kaka te",
    reference: "Yakobo 2:1-9",
    context: "Azali koponaka kati na bazwi mpe babola te"
  },
  {
    category: "Bolingo",
    text: "Yesu azali kanda kaka te",
    reference: "Yoane 13:1",
    context: "Alingaki biso tii na nsuka"
  },
  {
    category: "Mawa",
    text: "Yesu azali moto ya makasi mingi na mibeko te",
    reference: "Marko 2:27",
    context: "Alobaki ete Sabala esalamaki mpo na moto, kasi moto mpo na Sabala te"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali ya bondeko moko ya liloba te",
    reference: "Yoane 4:21-24",
    context: "Azali koteya kosambela ya bato nyonso na molimo mpe na bosolo"
  },
  {
    category: "Bokokani",
    text: "Yesu azali kosenga makambo ya mpasi ya liloba te",
    reference: "Matai 18:3",
    context: "Azali kosenga kondima ya pete lokola ya mwana"
  },
  {
    category: "Bolingo",
    text: "Yesu azali kobomba kanda te",
    reference: "1 Petelo 2:23",
    context: "Tango bafingaki ye, afingaki te na nsima"
  },
  {
    category: "Mawa",
    text: "Yesu azali monyokoli te",
    reference: "Matai 11:30",
    context: "Ekangiseli na Ye ezali pɛtɛɛ mpe mokumba na Ye moke"
  },
  {
    category: "Koyamba bato nyonso",
    text: "Yesu azali koponaka kolanda mibu te",
    reference: "Marko 10:14",
    context: "Azali koyamba bana mpe kopesa lokumu na mikolo"
  },
  {
    category: "Bolingo",
    text: "Yesu ayaki kopamela basumuki te",
    reference: "Yoane 8:11",
    context: "Alobaki na mwasi oyo asalaki ekobo: 'Ngai mpe napameli yo te'"
  }
];

export default jesusIsNotRc;
